var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "searchBar search__grid--fullLength" }, [
    _c("div", { attrs: { id: "searchbar", role: "search" } }, [
      _c("div", { staticClass: "searchbar__grid searchBar__focus" }, [
        _c(
          "div",
          { staticClass: "searchBar__input searchBar__input--mobile" },
          [
            !_vm.isMobile
              ? _c(
                  "svg",
                  {
                    staticClass: "text-color--gray-blue searchIcon__left",
                    attrs: { height: "16", width: "16", "aria-hidden": "true" },
                  },
                  [
                    _c("use", {
                      attrs: { href: "#iconMagnifyingGlassRegular" },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("search-autocomplete", {
              staticClass: "searchbar__autocomplete searchBar__rebrushInput",
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "button button--primary searchBar__button hideOnMobile",
                attrs: {
                  type: "button",
                  "data-content": "",
                  name: _vm.trans("SEARCH"),
                  "data-gtm": "search__refreshButton",
                  "aria-label": _vm.trans("SEARCH_REFRESH"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.startSearch.apply(null, arguments)
                  },
                },
              },
              [_c("span", [_vm._v(" " + _vm._s(_vm.trans("SEARCH")) + " ")])]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "button button--primary search__icon__button searchBar__buttonIcon hideOnDesktop",
            attrs: {
              type: "button",
              "data-content": "",
              name: _vm.trans("SEARCH"),
              "data-gtm": "search__refreshButton",
              "aria-label": _vm.trans("SEARCH_REFRESH"),
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startSearch.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "homeSearch__submitIcon padding-left-0",
                attrs: { height: "15", width: "15", "aria-hidden": "true" },
              },
              [_c("use", { attrs: { href: "#iconMagnifyingGlassBold" } })]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }